<template>
  <div class="text-center py-5" role="status" aria-label="Loading">
    <div class="loader-spinner inline-block w-8 h-8 border-3 border-border border-t-primary rounded-full"></div>
  </div>
</template>

<script>
/*
This component listens for specific event emissions
in order to show & hide the global loading dialog.
*/
export default {
  data () {
    return {
      isLoading: false
    }
  },
  mounted () {
    this.EventHolder.$on('startLoading', () => {
      this.isLoading = true
    })
    this.EventHolder.$on('stopLoading', () => {
      this.isLoading = false
    })
  }
}
</script>

<style scoped>
.loader-spinner {
  animation: loader-spin 0.6s linear infinite;
}

@keyframes loader-spin {
  to { transform: rotate(360deg); }
}
</style>
